const prefix = 'chart'

const type = {
    LOAD_DATA_TASK_USER_AND_SYSTEM: prefix + 'LOAD_DATA_TASK_USER_AND_SYSTEM',
    LOAD_DATA_TASK_USER_AND_SYSTEM_DONE:
        prefix + 'LOAD_DATA_TASK_USER_AND_SYSTEM_DONE',
    LOAD_DATA_TASK_SYSTEM_CHART: prefix + 'LOAD_DATA_TASK_SYSTEM_CHART',
    LOAD_DATA_TASK_SYSTEM_CHART_DONE:
        prefix + 'LOAD_DATA_TASK_SYSTEM_CHART_DONE',

    LOAD_DATA_CHART_EVENT_OBJECT: prefix + 'LOAD_DATA_CHART_EVENT_OBJECT',
    LOAD_DATA_CHART_EVENT_OBJECT_DONE:
        prefix + 'LOAD_DATA_CHART_EVENT_OBJECT_DONE',
    LOAD_DATA_CHART_OBJECT_EVENT: prefix + 'LOAD_DATA_CHART_OBJECT_EVENT',
    LOAD_DATA_CHART_OBJECT_EVENT_DONE:
        prefix + 'LOAD_DATA_CHART_OBJECT_EVENT_DONE',
    LOAD_DATA_COLECTED_BY_TIER: 'LOAD_DATA_COLECTED_BY_TIER',
    LOAD_DATA_COLECTED_BY_TIER_DONE: 'LOAD_DATA_COLECTED_BY_TIER_DONE',
    LOAD_DATA_CHART_USER_TASK: 'LOAD_DATA_CHART_USER_TASK',
    LOAD_DATA_CHART_USER_TASK_DONE: 'LOAD_DATA_CHART_USER_TASK_DONE',
    LOAD_DATA_CHART_ORG_TASK: 'LOAD_DATA_CHART_ORG_TASK',
    LOAD_DATA_CHART_ORG_TASK_DONE: 'LOAD_DATA_CHART_ORG_TASK_DONE',
    LOAD_DATA_CHART_USER_COLLECTED: 'LOAD_DATA_CHART_USER_COLLECTED',
    LOAD_DATA_CHART_USER_COLLECTED_DONE: 'LOAD_DATA_CHART_USER_COLLECTED_DONE',
    GET_LIST_DATA_EVENT_DASHBOARD: 'GET_LIST_DATA_EVENT_DASHBOARD',
    GET_LIST_DATA_EVENT_DASHBOARD_DONE: 'GET_LIST_DATA_EVENT_DASHBOARD_DONE',
    GET_LIST_DATA_TASK_USER: 'GET_LIST_DATA_TASK',
    GET_LIST_DATA_TASK_ADMIN: 'GET_LIST_DATA_TASK_ADMIN',
    GET_LIST_DATA_TASK_DONE: 'GET_LIST_DATA_TASK_DONE',
}

const action = {
    getListDataTaskUser: (uid, page_number, page_size, deleted, isRefresh) => {
        return {
            type: type.GET_LIST_DATA_TASK_USER,
            payload: { uid, page_number, page_size, deleted, isRefresh },
        }
    },
    getListDataTaskAdmin: (page_number, page_size, deleted, isRefresh) => {
        return {
            type: type.GET_LIST_DATA_TASK_ADMIN,
            payload: { page_number, page_size, deleted, isRefresh },
        }
    },
    getListDataTaskDone: (data, total, isRefresh) => {
        return {
            type: type.GET_LIST_DATA_TASK_DONE,
            payload: { data, total, isRefresh },
        }
    },
    getListEventDashboard: (begin_time, end_time, mode) => {
        return {
            type: type.GET_LIST_DATA_EVENT_DASHBOARD,
            payload: { begin_time, end_time, mode },
        }
    },
    getListEventDashboardDone: (data, mode) => {
        return {
            type: type.GET_LIST_DATA_EVENT_DASHBOARD_DONE,
            payload: { data, mode },
        }
    },
    loadDataChartUserCollected: (
        typeSelect,
        month,
        year,
        begin_time,
        end_time
    ) => {
        return {
            type: type.LOAD_DATA_CHART_USER_COLLECTED,
            payload: { typeSelect, month, year, begin_time, end_time },
        }
    },
    loadDataChartUserCollectedDone: data => {
        return {
            type: type.LOAD_DATA_CHART_USER_COLLECTED_DONE,
            payload: { data },
        }
    },
    loadDataChartOrgTask: (typeSelect, month, year, begin_time, end_time) => {
        return {
            type: type.LOAD_DATA_CHART_ORG_TASK,
            payload: { typeSelect, month, year, begin_time, end_time },
        }
    },
    loadDataChartOrgTaskDone: data => {
        return {
            type: type.LOAD_DATA_CHART_ORG_TASK_DONE,
            payload: { data },
        }
    },
    loadDataChartUserTask: (typeSelect, begin_time, end_time, month, year) => {
        return {
            type: type.LOAD_DATA_CHART_USER_TASK,
            payload: { typeSelect, begin_time, end_time, month, year },
        }
    },
    loadDataChartUserTaskDone: data => {
        return {
            type: type.LOAD_DATA_CHART_USER_TASK_DONE,
            payload: { data },
        }
    },
    loadDataCollectedByTier: (typeSelect, month, year) => {
        return {
            type: type.LOAD_DATA_COLECTED_BY_TIER,
            payload: { typeSelect, month, year },
        }
    },
    loadDataCollectedByTierDone: data => {
        return {
            type: type.LOAD_DATA_COLECTED_BY_TIER_DONE,
            payload: { data },
        }
    },
    loadDataChartUserSystem: (typeSelect, month, year) => {
        return {
            type: type.LOAD_DATA_TASK_USER_AND_SYSTEM,
            payload: { typeSelect, month, year },
        }
    },
    loadDataChartUserSystemDone: data => {
        return {
            type: type.LOAD_DATA_TASK_USER_AND_SYSTEM_DONE,
            payload: { data },
        }
    },
    loadDataChartSystemTask: (typeSelect, month, year) => {
        return {
            type: type.LOAD_DATA_TASK_SYSTEM_CHART,
            payload: { typeSelect, month, year },
        }
    },
    loadDataChartSystemTaskDone: data => {
        return {
            type: type.LOAD_DATA_TASK_SYSTEM_CHART_DONE,
            payload: { data },
        }
    },

    loadDataChartEventObject: (
        typeSelect,
        month,
        year,
        begin_time,
        end_time,
        page_number,
        page_size,
        isRefresh
    ) => {
        return {
            type: type.LOAD_DATA_CHART_EVENT_OBJECT,
            payload: {
                typeSelect,
                month,
                year,
                begin_time,
                end_time,
                page_number,
                page_size,
                isRefresh,
            },
        }
    },
    loadDataChartEventObjectDone: (data, index, isRefresh) => {
        return {
            type: type.LOAD_DATA_CHART_EVENT_OBJECT_DONE,
            payload: { data, index, isRefresh },
        }
    },
    loadDataChartObjectEvent: (
        typeSelect,
        month,
        year,
        begin_time,
        end_time,
        page_number,
        page_size,
        isRefresh
    ) => {
        return {
            type: type.LOAD_DATA_CHART_OBJECT_EVENT,
            payload: {
                typeSelect,
                month,
                year,
                begin_time,
                end_time,
                page_number,
                page_size,
                isRefresh,
            },
        }
    },
    loadDataChartObjectEventDone: (data, index, isRefresh) => {
        return {
            type: type.LOAD_DATA_CHART_OBJECT_EVENT_DONE,
            payload: { data, index, isRefresh },
        }
    },
}

export default {
    type,
    action,
}
